import SideBar from "../../../components/SideBar";
import { Main } from "../../styled";
import { useState } from "react";
import InputSearch from "../../../components/InputSearch";
import CardGrupo from "../../../components/Cards/CardGrupo";
import ControllerGrupos from "./controller";
import { useEffect } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import arvore_image from "../../../../assets/arvore.png";
import add_icone from "../../../../assets/icons/add.png";
import NovoGrupoModal from "../NovoGrupoModal";
import Esqueleto, { Recarregando } from "../../../components/Esqueleto";
import Paginacao from "../../../components/Paginacao";

function Home({usuario, errors, setErrors}){
  const [showNovoGrupoModal, setShowNovoGrupoModal] = useState(false);
  // Comeca true: a primeira pintura ja e o esqueleto, sem um quadro vazio antes.
  const [loading, setLoading] = useState(true);
  const [ meusGrupos, setMeusGrupos ] = useState();
  const [ grupos, setGrupos ] = useState();
  const [ pageMeusGrupos, setPageMeusGrupos ] = useState(1);
  const [ page, setPage ] = useState(1);
  const [ porPagina, setPorPagina ] = useState(12);
  // Sobe quando um grupo novo e criado: refaz as listas.
  const [ versao, setVersao ] = useState(0);
  const [ search, setSearch ] = useState('');
  const [typingTimeout, setTypingTimeout] = useState();

  const controllerGrupos =  new ControllerGrupos(usuario, errors, setErrors, setLoading, page, setPage, search, setSearch, grupos, setGrupos, meusGrupos, setMeusGrupos, pageMeusGrupos, setPageMeusGrupos);

  // Carrega as listas inteiras; quem pagina e o <Paginacao> abaixo de cada secao.
  useEffect(()=>{
    if (!usuario?.id) return;
    controllerGrupos.findMeusGrupos();
    controllerGrupos.findAllGrupos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario, search, versao]);

  // Ainda nao chegou NENHUMA resposta: so ai o esqueleto ocupa o lugar das listas.
  const primeiraCarga = loading && !meusGrupos && !grupos;
  const fatia = (lista, pagina) => (lista?.rows || []).slice((pagina - 1) * porPagina, pagina * porPagina);
  const mudarPorPagina = (n) => { setPorPagina(n); setPage(1); setPageMeusGrupos(1); };

  return(
    <SideBar>
      <Main>
        { showNovoGrupoModal && <NovoGrupoModal onClose={()=>setShowNovoGrupoModal(false)} atualizarGrupos={()=>setVersao((v) => v + 1)}/> }
        <div className="content">
          
          <section>
            <div className="top">
              <div className="title">
                <h2>Grupos</h2>
                <span>Acesse seus grupos preferidos e conheça novos plantadores.</span>
              </div>
              <InputSearch text="Pesquisar grupo" onChangeCapture={(e) => controllerGrupos.handleSearch(e, typingTimeout, setTypingTimeout)}/>
            </div>
          </section>

          <button type="button" onClick={()=>setShowNovoGrupoModal(true)}>
            <img src={add_icone} alt="Icone de adicionar"/>
            Criar um novo grupo
          </button>

          {/* Primeira carga: esqueleto no formato dos cartoes (nada de overlay "Aguarde"). */}
          {primeiraCarga && <Esqueleto variante="cartao" quantidade={6} rotulo="Carregando grupos" />}

          {/* Recarga (busca, voltar de um grupo): mantem a lista antiga, mais clara, sem piscar vazia. */}
          <Recarregando $ativo={loading && !primeiraCarga} aria-busy={loading && !primeiraCarga}>
          { meusGrupos?.rows?.length > 0 &&
            <section>
              <h2>Meus Grupos</h2>
              <div className="painel">
                {
                  fatia(meusGrupos, pageMeusGrupos).map((grupo) => (
                    <CardGrupo key={`meu-${grupo.id}`} grupo={grupo} link={grupo?.id}/>
                  ))
                }
              </div>
              <Paginacao pagina={pageMeusGrupos} total={meusGrupos.rows.length} porPagina={porPagina} itens="grupos"
                opcoes={[6, 12, 24]} onMudarPagina={setPageMeusGrupos} onMudarPorPagina={mudarPorPagina} />
            </section>
          }

          { grupos?.rows?.length > 0 &&
            <section>
              <h2>Grupos para conhecer</h2>
              <div className="painel">
                {
                  fatia(grupos, page).map(grupo => (
                    <CardGrupo key={`conhecer-${grupo.id}`} grupo={grupo} linkConhecer={`/grupos/${grupo.id}/conhecer`}/>
                  ))
                }
              </div>
              <Paginacao pagina={page} total={grupos.rows.length} porPagina={porPagina} itens="grupos"
                opcoes={[6, 12, 24]} onMudarPagina={setPage} onMudarPorPagina={mudarPorPagina} />
            </section>
          }

          {
            (!loading && grupos?.rows?.length === 0 && meusGrupos?.rows?.length === 0) &&
            <div className="painel-empty">
              <img src={arvore_image} alt="Icone de uma árvore"/>
              <span>Ainda não há nada aqui. Seja o primeiro a criar um grupo...</span>
            </div>
          }

          </Recarregando>

        </div>
      </Main>
    </SideBar>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);